export default __webpack_public_path__ + "files/7b1ba86e4759beab4087cfa8df719bd7.jpg";